/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserDto } from '../../models/center-user-dto';

export interface CenterUserControllerFindByUserIdAndCenterId$Params {
  centerId: string;
  userId: string;
}

export function centerUserControllerFindByUserIdAndCenterId(http: HttpClient, rootUrl: string, params: CenterUserControllerFindByUserIdAndCenterId$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerFindByUserIdAndCenterId.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterUserDto>;
    })
  );
}

centerUserControllerFindByUserIdAndCenterId.PATH = '/api/center-user/{centerId}/users/user-center';
